function AboutUs() {
    return ( <div>
        <h1>heyyyy !</h1>
    </div> );
}

export default AboutUs;